import Vue from 'vue';
import { DataService } from '../../data.service';

const chartID = 'getLandCoverChangeSummaryTableFor_Reporting';
/**
 * Tab 1: General: Land Cover Area and Change Distribution
 * getLandCoverChangeSummaryTableFor_Reporting
 */
export class Tab1Chart4 {
    constructor(options) {
        this.options = options || {};
        this.dataService = new DataService();
    }

    initialize() {
        //one data load start
        this.dataService.on('loadingData', () => {
            this.chart.infographic.loading = true;
        });

        //one data load complete
        this.dataService.on(chartID, (event, response) => {
            if (response.error) {
                console.error(`WEB SERVICE ERROR: ${event}`, response.error.data);
            }
            else {
                if (this.dataService.getDebugServices()) console.log(`${event}`, response.data.LandCoverAtlas);
                this.updateChartData(response.data.LandCoverAtlas, response.data.fromYear, response.data.toYear);
            }
        })
        this.renderChart();
    }

    updateChartData(response, fromYear, toYear) {
        this.chart.classes = response;
        this.chart.infographic.fromYear = fromYear;
        this.chart.infographic.toYear = toYear;
        this.chart.infographic.loading = false;
    }

    renderChart() {
        this.chart = new Vue({
            el: `#${chartID}`,
            data() {
                return {
                    infographic: {
                        title: 'Land Cover Area and Change Distribution',
                        loading: true,
                        fromYear: 1996,
                        toYear: 2010
                    },
                    classes: []
                }
            },
            filters: {
                short: (value) => {
                    //eg: Developed, High Intensity (HID) => HID
					return value.match(/\(([^)]+)\)/)[1];
                }
            }
        });
        //end vue component
    }
}
